export class ItemNotFoundException extends Error {}
export class ItemNotUploadedException extends Error {}
export class ItemNotUpdatedException extends Error {}
export class DuplicatedItemInDatabase extends Error {}
export class ComponentNotFoundException extends Error {}
export class ItemCannotBeDeleted extends Error {}
export class ItemCannotBeUpdated extends Error {}
export class CannotGetResponseFromMicroService extends Error {}
export class EmailCoudntBeSent extends Error {}
